import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from './stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue'),
    meta: { public: true },
  },
  { path: '/sign-in', redirect: '/login' },
  { path: '/sign-up', redirect: '/signup' },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('./views/Signup.vue'),
    meta: { public: true },
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('./views/Onboarding.vue'),
  },
  {
    path: '/',
    component: () => import('./layouts/AppLayout.vue'),
    children: [
      { path: 'dashboard', name: 'dashboard', component: () => import('./views/Dashboard.vue') },
      { path: 'leads', name: 'leads', component: () => import('./views/Leads.vue') },
      { path: 'forms', name: 'forms', component: () => import('./views/Forms.vue') },
      { path: 'visitors', name: 'visitors', component: () => import('./views/Visitors.vue') },
      {
        path: 'acquisition',
        name: 'acquisition',
        component: () => import('./views/Acquisition.vue'),
      },
      { path: 'funnels', name: 'funnels', component: () => import('./views/Funnels.vue') },
      { path: 'chat', name: 'chat', component: () => import('./views/Chat.vue') },
      { path: 'settings', name: 'settings', component: () => import('./views/Settings.vue') },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('./views/NotFound.vue'),
    meta: { public: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.ready) await auth.init()
  if (to.meta.public) return true
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name !== 'onboarding' && !auth.activeOrgId) {
    return { name: 'onboarding' }
  }
  return true
})
